import { render, staticRenderFns } from "./studySituation.vue?vue&type=template&id=d871216e&scoped=true&"
import script from "./studySituation.js?vue&type=script&lang=js&"
export * from "./studySituation.js?vue&type=script&lang=js&"
import style0 from "./studySituation.vue?vue&type=style&index=0&id=d871216e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d871216e",
  null
  
)

export default component.exports